import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
  name: "MixoraPage",
  data() {
    let ss = new MainService();
    return {
      msg: "MixoraPage",
      ss: ss,
      ajax: {
        url: ss.indexMixora(),
        headers: ss.getToken(),
      },
      columns: [
        {
          data: "id",
          name: "id",
          orderable: false,
          searchable: false,
          visible: false,
        },
        {
          data: "DT_RowIndex",
          name: "DT_RowIndex",
          title: "N",
          orderable: false,
          searchable: false,
        },
        { data: "Mixora", name: "Mixora", title: "Mixora" },
        { data: "RGB", name: "RGB", title: "RGB" },
        {
          data: "RGB",
          searchable: false,
          name: "RGB",
          title: "Mixora Color",
          render: function (data, type, row) {
            if (row.RGB) {
              return (
                '<div style="background-color:rgb(' +
                row.RGB +
                ');"> </br></br></div>'
              );
            } else {
              return '<div style="background-color:red;"> </br>ERROR COLOR</br></div>';
            }
          },
        },
        {
          data: "Activo",
          name: "Activo",
          title: "Status",
          className: "centradito",
          render: function (data, type, row) {
            if (!row.Activo) {
              return '<i class="fa fa-ban text-danger"></i>';
            } else {
              return '<i class="fa fa-check text-success"></i>';
            }
          },
        },
        {
          data: "action",
          orderable: false,
          title: "Actions",
          searchable: false,
        },
      ],
      mixoras: [],
      mixora: {},
      isLoading: false,
      errorBag: {},
    };
  },
  methods: {
    newMixora() {
      this.mixora = {};
      this.$refs["frm-mixora"].show();
    },
    showMixora(id) {
      this.isLoading = true;
      this.ss
        .showMixora(id)
        .then((result) => {
          let response = result.data;
          this.mixora = response.data;
          this.$refs["view-mixora"].show();
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    editMixora() {
      this.$refs["frm-mixora"].show();
      this.$refs["view-mixora"].hide();
    },
    cancelMixora() {
      if (this.mixora.id) {
        this.$refs["view-mixora"].show();
      }
      this.$refs["frm-mixora"].hide();
    },
    saveMixora() {
      this.ss
        .storeMixora(this.mixora)
        .then((result) => {
          console.log(result);
          let response = result.data;
          this.$bvToast.toast(response.msg, {
            title: this.$t("messages.success"),
            variant: "success",
            autoHideDelay: 5000,
          });
          //this.$refs['view-consulta'].show(); //para volver al modal
          console.log(response);
          this.$refs["frm-mixora"].hide();
          this.$refs["datatable-mixora"].reload();
        })
        .catch((error) => {
          this.errorBag = error.response.data.errors;
          this.$bvToast.toast(this.$t("messages.problemSave"), {
            title: "Error",
            variant: "danger",
            autoHideDelay: 5000,
          });
        });
    },
    deleteMixora() {
      this.$swal({
        title: "Estas seguro que deseas eliminar?",
        text: "Esta accion es irreversible!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete.isConfirmed) {
          this.ss
            .destroyMixora(this.mixora)
            .then((result) => {
              let response = result.data;
              console.log(response);
              this.$bvToast.toast(response.msg, {
                title: this.$t("messages.success"),
                variant: "success",
                autoHideDelay: 5000,
              });
              this.$refs["view-mixora"].hide();
              this.$refs["datatable-mixora"].reload();
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          //swal("Your imaginary file is safe!");
        }
      });
    },
    draw() {
      window.$(".btn-datatable-Mixora").on("click", (evt) => {
        const data = window.$(evt.target)[0].id;
        this.showMixora(data);
      });
    },
  },
  components: {
    dataTable,
    Loader,
  },
  mounted() {
    var persona = JSON.parse(localStorage.getItem("persona"));
    if (!persona) {
      this.$router.push("/Admin/Login");
    } else {
      if (persona.Rol !== 1) {
        this.$router.push("/Admin/Login");
      }
    }
  },
};
